import React from "react";
import Feature from "../../components/Feature/Feature";
import "./About.css";

const About = () => (
  <div className="aboutSection section__margin " id="about">
    <div className="aboutSection-feature">
      <div className="features-container__feature">
        <div className="features-container__feature-title">
          <div />
          <h1>
            what is <span className="gradient__text">code-zephyr?</span>
          </h1>
        </div>
        <div className="features-container_feature-text">
          <p className="code-zephyr-desc">
            <span className="gradient__text">code-zephyr</span> stands for our
            ideals and principles. Where code refers to our technological theme
            of work and zephyr literally meaning a west wind.
          </p>
        </div>
      </div>
    </div>
    <div className="aboutSection-heading">
      <h1 className="gradient__text ">
        We build efficient and robust solutions and transform businessses.
      </h1>
      <p>Explore our work</p>
    </div>
    <div className="aboutSection-container">
      <Feature
        title="Web Development"
        text="We make professional and efficient websites for businesses looking to further their reach on the internet"
      />
      <Feature
        title="Cross-Platform Apps"
        text="Our applications are designed to be robust and efficient and offer a seamless user experience"
      />
      <Feature
        title="Blockchain Solutions"
        text="Dont miss out on the blockchain boom like you did on the dot com boom. Lets work together!"
      />
    </div>
  </div>
);

export default About;
